import Message from "./Message";

const keyupHandler = (event: KeyboardEvent): void => {
    const isEscapeKey = event.key === "Escape" || (event.keyCode || event.which) === 27;

    if (isEscapeKey) {
        Message.userCloseWindow();
    }
};

export default keyupHandler;
